import React, { useContext, useEffect, useState, useCallback } from "react";
import Header from "../../Components/comman/Header";
import { Container, Button, Modal } from "react-bootstrap";
import Select from "react-select";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { CgHeart } from "react-icons/cg";
import { IoMdHeart } from "react-icons/io";
import { CgDanger } from "react-icons/cg";
import { MdOutlineCheckCircle } from "react-icons/md";
import MobileHeader from "../../Components/comman/MobileHeader";
import Images from "../../Helpers/Images";
import { useLocation, useNavigate } from "react-router-dom";
import { toaster, Notification } from "rsuite";
import { APIRequest, ApiUrl } from "../../Helpers/ApiHelper";
import { Auth } from "../../Contexts/AuthContext";
import ProductGallery from "../../Components/comman/ProductGallery";
import InspritionGallery from "../../Components/comman/InspritionGallery";
import CustomLoader from "../../Components/comman/Loader/CustomLoader";

const platformIcons = {
  instagram: Images.instagram,
  tiktok: Images.tikTok,
  youtube: Images.youtube,
};

const ProductDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const product = location.state?.product;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { auth } = useContext(Auth);
  const [showPlatformModal, setShowPlatformModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [selectedPlatforms, setSelectedPlatforms] = useState([]);
  const [isWishlisted, setIsWishlisted] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isCheckingWishlist, setIsCheckingWishlist] = useState(false);
  const [workPlatformsData, setWorkPlatformsData] = useState([]);
  const [phylloConnectedAccounts, setPhylloConnectedAccounts] = useState([]);
  const [connectionStatus, setConnectionStatus] = useState({});
  const [isFetchingProfiles, setIsFetchingProfiles] = useState(false);
  const [IsOptingIn, setIsOptingIn] = useState(false);
  const [selectedPlatformForOptIn, setSelectedPlatformForOptIn] =
    useState(null);

  const isInfluencer = useCallback(() => {
    return auth?.userRole === "INFLUENCER";
  }, [auth?.userRole]);
  const isBrand = useCallback(() => {
    return auth?.userRole === "BRAND";
  }, [auth?.userRole]);

  const handleClosePlatformModal = () => {
    setShowPlatformModal(false);
    setSelectedPlatforms([]);
  };
  const handleShowPlatformModal = () => setShowPlatformModal(true);

  const handleCloseConfirmationModal = () => {
    setShowConfirmationModal(false);
    setSelectedPlatforms([]);
  };
  const checkWishlistStatus = useCallback(async () => {
    if (!auth?.token || !product?.id || !isInfluencer()) {
      setIsWishlisted(false);
      setIsCheckingWishlist(false);
      return;
    }

    setIsCheckingWishlist(true);
    try {
      const config = {
        url: ApiUrl.getWishlist,
        method: "GET",
      };
      APIRequest(
        config,
        (response) => {
          const wishlistItems = response?.data || [];
          const isInWishlist = wishlistItems.some(
            (item) => item.campaign_id === product.id || item.id === product.id
          );
          setIsWishlisted(isInWishlist);
          setIsCheckingWishlist(false);
        },
        (error) => {
          console.error("Error checking wishlist:", error);
          setIsWishlisted(false);
          setIsCheckingWishlist(false);
        }
      );
    } catch (error) {
      console.error("Error checking wishlist:", error);
      setIsCheckingWishlist(false);
    }
  }, [auth?.token, product?.id, isInfluencer]);
  useEffect(() => {
    const initializePage = async () => {
      setIsLoading(true);
      if (isBrand()) {
        setIsWishlisted(false);
        setWorkPlatformsData([]);
        setIsLoading(false);
        return;
      }
      if (isInfluencer() && auth?.token && product?.id) {
        await checkWishlistStatus();
        getAllWorkPlatforms();
      } else {
        setIsWishlisted(false);
        setWorkPlatformsData([]);
      }

      setIsLoading(false);
    };

    initializePage();
  }, [auth?.token, product?.id, isInfluencer, isBrand, checkWishlistStatus]);

  const getAllWorkPlatforms = () => {
    if (!isInfluencer()) {
      setWorkPlatformsData([]);
      return;
    }

    let config = {
      url: ApiUrl.getWorkPlatforms,
      method: "GET",
      body: {},
    };
    APIRequest(
      config,
      (res) => {
        const data = res?.data;
        setWorkPlatformsData(data);
      },
      (err) => {
        console.log("error", err);
        setWorkPlatformsData([]);
      }
    );
  };

  const handleAddToWishlist = () => {
    if (!isInfluencer()) {
      toaster.push(
        <Notification type="warning" header="Feature Not Available" closable>
          This feature is only available for influencers.
        </Notification>,
        { placement: "topCenter" }
      );
      return;
    }
    if (!auth?.token) {
      toaster.push(
        <Notification type="warning" header="Authentication Required" closable>
          Please login to add items to wishlist
        </Notification>,
        { placement: "topCenter" }
      );
      return;
    }

    const isAddingToWishlist = !isWishlisted;
    const url = isAddingToWishlist
      ? ApiUrl.addToWishlist
      : ApiUrl.removeFromWishlist;

    let config = {
      url: url,
      method: isAddingToWishlist ? "POST" : "DELETE",
      body: { campaign_id: product?.id },
    };

    setIsCheckingWishlist(true);
    APIRequest(
      config,
      (response) => {
        setIsWishlisted(isAddingToWishlist);
        toaster.push(
          <Notification type="success" header="Success" closable>
            {response?.message ||
              `Item ${
                isAddingToWishlist ? "added to" : "removed from"
              } wishlist`}
          </Notification>,
          { placement: "topCenter" }
        );
        setIsCheckingWishlist(false);
      },
      (err) => {
        setIsWishlisted(!isAddingToWishlist);
        toaster.push(
          <Notification type="error" header="Error" closable>
            {err?.response?.data?.message ||
              `Failed to ${
                isAddingToWishlist ? "add to" : "remove from"
              } wishlist`}
          </Notification>,
          { placement: "topCenter" }
        );
        setIsCheckingWishlist(false);
      }
    );
  };

  // date format
  function formatDate(dateString) {
    const options = { year: "numeric", month: "long", day: "numeric" };
    const date = new Date(dateString);
    return date.toLocaleDateString(undefined, options);
  }

  const fetchProfiles = () => {
    if (!isInfluencer()) {
      toaster.push(
        <Notification type="warning" header="Feature Not Available" closable>
          This feature is only available for influencers.
        </Notification>,
        { placement: "topCenter" }
      );
      return;
    }

    setIsFetchingProfiles(true);
    let config = {
      url: ApiUrl.getPhylloSocialAccounts,
      method: "GET",
      body: {},
    };
    APIRequest(
      config,
      (res) => {
        const data = res?.data;
        setPhylloConnectedAccounts(data);
        setIsFetchingProfiles(false);
        if (selectedPlatforms.length > 0) {
          checkConnectionStatus(data);
        }
      },
      (err) => {
        console.log("error++", err);
        setIsFetchingProfiles(false);
      }
    );
  };

  const checkConnectionStatus = (connectedAccounts) => {
    const status = {};
    selectedPlatforms.forEach((platform) => {
      const platformKey = platform.name.toLowerCase();
      const connectedAccount = connectedAccounts.find(
        (account) =>
          account.platform?.toLowerCase() === platformKey ||
          account.profile?.platform?.toLowerCase() === platformKey
      );
      if (connectedAccount) {
        if (connectedAccount.status === "CONNECTED") {
          let followerCount = 0;
          let engagementRate = connectedAccount.engagement_rate;

          if (platformKey === "youtube") {
            followerCount =
              connectedAccount?.profile?.raw_payload?.reputation
                ?.subscriber_count || 0;
          } else {
            followerCount =
              connectedAccount?.profile?.raw_payload?.reputation
                ?.follower_count || 0;
          }
          const campaignPlatform = product?.campaign_platform?.find(
            (cp) => cp.name.toLowerCase() === platformKey
          );

          const requiredFollower =
            campaignPlatform?.social_engagement_data?.follower || 0;
          const requiredEngagement =
            campaignPlatform?.social_engagement_data?.engagement || 0;
          const meetsFollowerRequirement = followerCount >= requiredFollower;
          const meetsEngagementRequirement =
            engagementRate >= requiredEngagement;
          const isEligible =
            meetsFollowerRequirement && meetsEngagementRequirement;

          if (connectedAccount.engagement_rate === null) {
            status[platform.id] = {
              connected: true,
              message:
                "Please be patient, we are fetching details. Try again after some time.",
              account: connectedAccount,
              hasEngagementData: false,
            };
          } else {
            status[platform.id] = {
              connected: true,
              message: isEligible ? "Eligible" : "Not Eligible",
              account: connectedAccount,
              followerCount,
              engagementRate,
              requiredFollower,
              requiredEngagement,
              isEligible,
              meetsFollowerRequirement,
              meetsEngagementRequirement,
              hasEngagementData: true,
            };
          }
        } else {
          status[platform.id] = {
            connected: false,
            message: `Your ${platform.name} account is not connected. Please connect it in your profile.`,
            account: null,
            hasEngagementData: false,
          };
        }
      } else {
        status[platform.id] = {
          connected: false,
          message: `Your ${platform.name} account is not connected. Please connect it in your profile.`,
          account: null,
          hasEngagementData: false,
        };
      }
    });

    setConnectionStatus(status);
  };

  const handleContinue = () => {
    if (selectedPlatforms.length > 0) {
      setShowPlatformModal(false);
      fetchProfiles();
      setShowConfirmationModal(true);
    }
  };

  const getAvailablePlatforms = () => {
    if (!isInfluencer()) return [];

    return workPlatformsData.filter((workPlatform) =>
      product?.campaign_platform?.some(
        (campaignPlatform) =>
          campaignPlatform.name.toLowerCase() ===
          workPlatform.name.toLowerCase()
      )
    );
  };

  const allPlatformsConnected =
    selectedPlatforms.length > 0 &&
    selectedPlatforms.every(
      (platform) =>
        connectionStatus[platform.id]?.connected &&
        connectionStatus[platform.id]?.hasEngagementData &&
        connectionStatus[platform.id]?.isEligible
    );

  const hasPendingEngagementData = selectedPlatforms.some(
    (platform) =>
      connectionStatus[platform.id]?.connected &&
      !connectionStatus[platform.id]?.hasEngagementData
  );

  const eligiblePlatforms = selectedPlatforms.filter(
    (platform) => connectionStatus[platform.id]?.isEligible
  );

  useEffect(() => {
    if (eligiblePlatforms.length === 1 && !selectedPlatformForOptIn) {
      setSelectedPlatformForOptIn(eligiblePlatforms[0].id);
    }
  }, [eligiblePlatforms, selectedPlatformForOptIn]);

  const navigateToAccounts = () => {
    handleCloseConfirmationModal();
    navigate("/influencer/account");
  };
  const handleOptInCampaign = (campaignId) => {
    if (!isInfluencer()) {
      toaster.push(
        <Notification type="warning" header="Feature Not Available" closable>
          This feature is only available for influencers.
        </Notification>,
        { placement: "topCenter" }
      );
      return;
    }

    setIsOptingIn(true);
    let config = {
      url: ApiUrl.optInCamapign,
      method: "POST",
      body: {
        campaign_id: campaignId,
      },
    };

    APIRequest(
      config,
      (res) => {
        setIsOptingIn(false);
        toaster.push(
          <Notification type="success" header="Success" closable>
            {res?.message || "Successfully opted into the campaign!"}
          </Notification>,
          { placement: "topCenter", duration: 3000 }
        );
        handleCloseConfirmationModal();
        setTimeout(() => {
          navigate("/influencer/campaigns");
        }, 1500);
      },
      (err) => {
        console.log("Opt-in error:", err);
        setIsOptingIn(false);
        toaster.push(
          <Notification type="error" header="Error" closable>
            {err?.message ||
              "Failed to opt into the campaign. Please try again."}
          </Notification>,
          { placement: "topCenter", duration: 4000 }
        );
      }
    );
  };

  return (
    <>
      <Header />
      <MobileHeader />
      <CustomLoader visible={isLoading} />

      <div className="productDetail-wrapper">
        <Container>
          {console.log("productDetail", product)}
          <div className="productDetail">
            <div className="title-box box">
              <p className="title">{product?.campaign_title} 🌟</p>
              <p className="launch-date">
                Launched :
                <span style={{ color: "#189f8e" }}>
                  {product?.created_at ? formatDate(product.created_at) : "N/A"}
                </span>
              </p>
              <p className="byName">
                <span>By</span> {product?.brand?.company_name}
              </p>
            </div>
            <div className="Slider-qualification-box">
              <div className="slider-about-box">
                <ProductGallery gallery={product.gallery} />
                <div className="box about-box">
                  <h5>About the {product?.brand?.company_name}</h5>
                  <p>{product?.brand?.brand_story}</p>
                </div>
              </div>
              {/* Qualifications */}
              <div className="qualification-box box">
                <h5>Qualifications</h5>
                <p className="desc">
                  <CgDanger /> You must meet the following requirements to
                  participate in this campaign. For multi-channel campaigns, you
                  need to meet the follower & engagement criteria for at least
                  one channel.
                </p>
                <ul className="content-list-box">
                  {product?.campaign_platform?.map((platform, index) => {
                    const platformKey = platform?.name?.toLowerCase()?.trim();
                    const icon =
                      platformIcons[platformKey] || "/assets/icons/default.png";
                    return (
                      <React.Fragment key={index}>
                        {/* Followers */}
                        <li>
                          <span>
                            <img src={icon} alt={platform?.platform_name} />
                            {platform?.platform_name} Followers
                          </span>
                          <span className="figureData">
                            {platform?.social_engagement_data?.follower || 0}+
                          </span>
                        </li>
                        {/* Engagement */}
                        <li>
                          <span>
                            <img src={icon} alt={platform?.platform_name} />
                            {platform?.platform_name} Engagement
                          </span>
                          <span className="figureData">
                            {platform?.social_engagement_data?.engagement || 0}
                            %+
                          </span>
                        </li>
                      </React.Fragment>
                    );
                  })}
                  {/* Age */}
                  <li>
                    <span>Age</span>
                    <span className="figureData">
                      {product?.age?.min}-{product?.age?.max}+
                    </span>
                  </li>
                  <li>
                    <span>Gender</span>
                    <div>
                      {product?.gender?.map((gender, index) => (
                        <span className="genderData" key={index}>
                          {gender}
                          {index !== product.gender.length - 1 && ", "}
                        </span>
                      ))}
                    </div>
                  </li>
                  {/* Residence */}
                  <li>
                    <span>Residence</span>
                    <div className="countryFlagBoxDetail">
                      {product?.countries?.map((country, index) => (
                        <img
                          alt="flag"
                          className="countryFlag"
                          key={index}
                          src={
                            country?.flag_url
                              ? country.flag_url
                              : "/default-platform.png"
                          }
                        />
                      ))}
                    </div>
                  </li>
                  {/* niche */}
                  <li>
                    <span className="option">Niche</span>
                    <span className="catagory">
                      {product?.categories?.map((item, i) => (
                        <span key={i}>{item.name}</span>
                      ))}
                    </span>
                  </li>
                </ul>
                {auth?.userRole === "INFLUENCER" && (
                  <div className="btn-section">
                    <Button
                      onClick={handleAddToWishlist}
                      disabled={isCheckingWishlist || !auth?.token}
                      className={`outlined-btn wish-btn ${
                        isWishlisted ? "wishlisted" : ""
                      }`}
                    >
                      {isCheckingWishlist ? (
                        <>Checking...</>
                      ) : (
                        <>
                          {isWishlisted ? <IoMdHeart /> : <CgHeart />}

                          {isWishlisted ? "Wishlisted" : "Wishlist"}
                        </>
                      )}
                    </Button>
                    {console.log("product.is_opted", product.is_opted)}
                    {product.is_opted === true ? (
                      <div className="alreadyOptedBox">
                        <p>Already Opted</p>
                      </div>
                    ) : (
                      <Button
                        className="theme-btn opt-btn"
                        onClick={handleShowPlatformModal}
                        disabled={isLoading}
                      >
                        Opt In
                      </Button>
                    )}
                  </div>
                )}
              </div>
            </div>
            <div className="deliverables-box box">
              <h5>Deliverables</h5>
              <div className="platform-detail">
                <span className="img-box">
                  {product?.campaign_platform.map((item, k) => (
                    <img
                      className="img-fluid"
                      src={item.logo}
                      key={k}
                      alt="platformImg"
                    />
                  ))}
                </span>
                <span>{product?.campaign_strategy_details?.name}</span>
                <span className="category">
                  {Object.entries(product?.content_format || {})
                    .filter(([key, val]) => val && val !== "0")
                    .map(([key, val]) => `${key}: ${val}`)
                    .join(" | ")}
                </span>
              </div>
              <div className="visuals-main-box">
                <h6>Visuals & Theme</h6>
                <p>
                  We want to hear your ideas! We want to make sure the content
                  still feels authentic to you and your audience while still
                  highlighting all the things you can accomplish with
                  {product?.brand?.company_name}
                </p>
                <p>We are looking for:</p>
                <p>{product?.visuals_theme}</p>

                <div className="boxes">
                  <div className="insprition-box inner_box">
                    <ul>
                      Do's
                      {product.what_to &&
                        product.what_to
                          .split("\n")
                          .filter((line) => line.trim() !== "")
                          .map((item, k) => {
                            const cleanText = item.replace(/^💥\s*/, "").trim();
                            return <li key={k}>💥 {cleanText}</li>;
                          })}
                    </ul>
                  </div>
                  <div className="visual-box inner_box">
                    <ul>
                      Do Not
                      {product.what_not_to &&
                        product.what_not_to
                          .split("\n")
                          .filter((line) => line.trim() !== "")
                          .map((item, k) => {
                            const cleanText = item.replace(/^💥\s*/, "").trim();
                            return <li key={k}>❎ {cleanText}</li>;
                          })}
                    </ul>
                  </div>
                </div>
              </div>
              <div className="bottom-boxes">
                <div className="captions inner_box">
                  <h6>Product Description</h6>
                  <p>{product?.product_description}</p>
                </div>
                <div className="hashtags inner_box">
                  <h6>Hashtags & Mentions</h6>
                  {product?.caption &&
                    product.caption.split(" ").map((word, index) => {
                      if (word.startsWith("#")) {
                        return (
                          <span key={index} className="hashtag">
                            {word}
                          </span>
                        );
                      } else if (word.startsWith("@")) {
                        return (
                          <span key={index} className="mention">
                            {word}
                          </span>
                        );
                      }
                      return null;
                    })}
                </div>
              </div>
            </div>
            <div className="compensation-camp-box">
              <div className="Compensation-box box">
                <h5>Campaign Details</h5>
                <p className="campagin-price">
                  <MdOutlineCheckCircle /> Paid campaign:
                  {product?.paid_campaign_payment
                    ? product.paid_campaign_payment.type === "fixed"
                      ? ` ${product.paid_campaign_payment.value}$ USD`
                      : ` ${product.paid_campaign_payment.value?.min}-${product.paid_campaign_payment.value?.max}$ USD`
                    : " N/A"}
                </p>
                <p className="desc">{product?.description}</p>
                <p className="retail-value">
                  Retail Value :{" "}
                  <span>
                    $
                    {product?.retail_value?.value &&
                    product?.retail_value?.type === "range"
                      ? `${product.retail_value.value.min}-${product.retail_value.value.max}`
                      : product?.retail_value?.value || "N/A"}
                  </span>
                </p>
              </div>
              <div className="campagin-box box">
                <h5>Inspiration</h5>
                <InspritionGallery
                  gallery={product?.inspiration_board?.map((url, index) => ({
                    id: index,
                    campaign_id: product?.id,
                    image_url: url,
                    created_at: new Date().toISOString(),
                    updated_at: new Date().toISOString(),
                  }))}
                />
              </div>
            </div>
          </div>
        </Container>

        {/* optIn modal */}
        <Modal
          show={showPlatformModal}
          onHide={handleClosePlatformModal}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="product-optIn-modal"
        >
          <Modal.Header closeButton>
            <h5>Connect Socials</h5>
          </Modal.Header>
          <Modal.Body>
            <p className="info-text">Please choose your socials accounts.</p>
            <Select
              isMulti
              options={getAvailablePlatforms().map((platform) => ({
                value: platform.id,
                label: platform.name,
                icon:
                  platformIcons[platform.name.toLowerCase()] ||
                  Images.defaultPlatform,
              }))}
              value={selectedPlatforms.map((platform) => ({
                value: platform.id,
                label: platform.name,
                icon:
                  platformIcons[platform.name.toLowerCase()] ||
                  Images.defaultPlatform,
              }))}
              onChange={(selectedOptions) => {
                const selected = getAvailablePlatforms().filter((platform) =>
                  selectedOptions.some((option) => option.value === platform.id)
                );
                setSelectedPlatforms(selected);
                if (selectedOptions.length === 1) {
                  setTimeout(() => {
                    const selectInput = document.querySelector(
                      ".platform-select input"
                    );
                    if (selectInput) {
                      selectInput.blur();
                    }
                  }, 0);
                }
              }}
              formatOptionLabel={(option) => (
                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <img
                    src={option.icon}
                    alt={option.label}
                    style={{ width: "20px", height: "20px" }}
                  />
                  <span>{option.label}</span>
                </div>
              )}
              className="platform-select"
              classNamePrefix="select"
              placeholder="Choose platforms..."
              closeMenuOnSelect={false}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={handleClosePlatformModal} className="cancel-btn">
              Cancel
            </Button>
            <Button
              className={`continue-btn ${
                selectedPlatforms.length > 0 ? "enabled" : "disabled"
              }`}
              onClick={handleContinue}
              disabled={selectedPlatforms.length === 0 || !isInfluencer()}
            >
              Continue
            </Button>
          </Modal.Footer>
        </Modal>
        {/* Confirmation Modal */}
        <Modal
          show={showConfirmationModal}
          onHide={handleCloseConfirmationModal}
          size="md"
          aria-labelledby="confirmation-modal-title"
          centered
          className="confirmation-modal"
        >
          <Modal.Header closeButton>
            <h5>Platform Selection</h5>
          </Modal.Header>
          <Modal.Body>
            {isFetchingProfiles ? (
              <p className="info-text">Fetching your connected accounts...</p>
            ) : phylloConnectedAccounts?.length === 0 ? (
              <p className="info-text">
                No connected accounts found. Please connect your accounts in
                your profile.
              </p>
            ) : (
              <>
                <div className="confirmation-content">
                  <p className="info-text">
                    {hasPendingEngagementData
                      ? "Please be patient, we are fetching details. Try again after some time."
                      : eligiblePlatforms?.length > 0
                      ? eligiblePlatforms?.length === 1
                        ? "One eligible platform found. You can proceed."
                        : `Multiple eligible platforms found. Please select one to continue.`
                      : "No eligible platforms found. Please check the requirements or connect other accounts."}
                  </p>
                  <div className="selected-platforms-list">
                    {selectedPlatforms?.map((platform, index) => {
                      const platformKey = platform.name.toLowerCase();
                      const platformIcon = platform?.logo_url;
                      const status = connectionStatus[platform.id];
                      if (!status) return null;
                      return (
                        <div
                          key={index}
                          className={`confirmed-platform-item ${
                            status.isEligible ? "eligible" : "not-eligible"
                          } ${
                            selectedPlatformForOptIn === platform.id
                              ? "selected"
                              : ""
                          }`}
                          onClick={() => {
                            if (
                              status.isEligible &&
                              eligiblePlatforms.length > 1
                            ) {
                              setSelectedPlatformForOptIn(platform.id);
                            }
                          }}
                        >
                          <div className="confirmed-platform-header">
                            <div className="platform-info">
                              <img src={platformIcon} alt={platform?.name} />
                              <span>{platform?.name}</span>
                              {status.isEligible &&
                                eligiblePlatforms.length > 1 && (
                                  <div className="select-indicator">
                                    <input
                                      type="radio"
                                      checked={
                                        selectedPlatformForOptIn === platform.id
                                      }
                                      onChange={() =>
                                        setSelectedPlatformForOptIn(platform.id)
                                      }
                                    />
                                  </div>
                                )}
                            </div>
                            {status.connected && status.hasEngagementData && (
                              <div className="status-badge">
                                <span
                                  className={`badge ${
                                    status.isEligible
                                      ? "eligible"
                                      : "not-eligible"
                                  }`}
                                >
                                  {status.isEligible
                                    ? "Eligible"
                                    : "Not Eligible"}
                                </span>
                              </div>
                            )}
                          </div>
                          <div className="status-details">
                            {!status.connected ? (
                              <p className="not-connected">
                                Account is not connected. Please connect in your
                                profile page.
                              </p>
                            ) : !status.hasEngagementData ? (
                              <p className="fetching-data">
                                Fetching engagement data...
                              </p>
                            ) : (
                              <>
                                <div className="account-info">
                                  <span>
                                    Connected : @
                                    {status.account.username ||
                                      status.account.profile?.username ||
                                      "N/A"}
                                  </span>
                                </div>
                                <div className="requirements-comparison">
                                  <div className="requirement-row">
                                    <span>Followers:</span>
                                    <span className="actual-count">
                                      {status.followerCount.toLocaleString()}
                                    </span>
                                    <span className="vs">vs</span>
                                    <span
                                      className={`required-count ${
                                        status.meetsFollowerRequirement
                                          ? "met"
                                          : "not-met"
                                      }`}
                                    >
                                      {status.requiredFollower.toLocaleString()}
                                      +
                                    </span>
                                    {status.meetsFollowerRequirement ? (
                                      <span className="checkmark">✓</span>
                                    ) : (
                                      <span className="cross">✗</span>
                                    )}
                                  </div>
                                  <div className="requirement-row">
                                    <span>Engagement:</span>
                                    <span className="actual-count">
                                      {status.engagementRate}%
                                    </span>
                                    <span className="vs">vs</span>
                                    <span
                                      className={`required-count ${
                                        status.meetsEngagementRequirement
                                          ? "met"
                                          : "not-met"
                                      }`}
                                    >
                                      {status.requiredEngagement}%+
                                    </span>
                                    {status.meetsEngagementRequirement ? (
                                      <span className="checkmark">✓</span>
                                    ) : (
                                      <span className="cross">✗</span>
                                    )}
                                  </div>
                                </div>
                                {!status.isEligible && (
                                  <p className="not-eligible-reason">
                                    Does not meet{" "}
                                    {!status.meetsFollowerRequirement &&
                                      "follower "}
                                    {!status.meetsFollowerRequirement &&
                                      !status.meetsEngagementRequirement &&
                                      "and "}
                                    {!status.meetsEngagementRequirement &&
                                      "engagement "}
                                    requirements
                                  </p>
                                )}
                              </>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button className="goBckBtn" onClick={handleCloseConfirmationModal}>
              Go Back
            </Button>
            {!isFetchingProfiles && (
              <>
                {eligiblePlatforms.length > 0 ? (
                  <Button
                    className="confirm-btn"
                    onClick={() => {
                      const selectedPlatform = selectedPlatforms.find(
                        (p) => p.id === selectedPlatformForOptIn
                      );
                      handleOptInCampaign(product?.id);
                    }}
                    disabled={
                      eligiblePlatforms.length > 1 && !selectedPlatformForOptIn
                    }
                  >
                    {eligiblePlatforms.length === 1
                      ? `Opt In with ${eligiblePlatforms[0].name}`
                      : selectedPlatformForOptIn
                      ? `Opt In with Selected Platform`
                      : "Select a Platform to Continue"}
                  </Button>
                ) : (
                  <Button className="confirm-btn" onClick={navigateToAccounts}>
                    Go to Accounts Page
                  </Button>
                )}
              </>
            )}
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

export default ProductDetails;
